import React from "react"

import ActorCard from "./ActorCard"
import styles from "./MainActorsList.module.scss"
import Heading from "../../../../components/shared/Heading";
import {useGetCastsListQuery} from "../../../../store/api/filmAPI";
import DotsLoader from "../../../../components/icons/DotsLoader";
import {useParams} from "react-router-dom";
import {languageHandler} from "../../../../utils/helpers";
import {useTranslation} from "react-i18next";

type Props = {
  sectionTitle: string
}

type CastMember = {
  adult: boolean;
  gender: number;
  id: number;
  known_for_department: string;
  name: string;
  original_name: string;
  popularity: number;
  profile_path: string;
  cast_id: number;
  character: string;
  credit_id: string;
  order: number;
  person: { id: number; name: string; profile_path: string | null } | null;
};

const MainActorsList = ({ sectionTitle }: Props) => {
  const { id } = useParams();
  const {i18n} = useTranslation();

  const { data, isLoading } = useGetCastsListQuery({
    queries: { language: languageHandler(i18n.language) },
    id: id,
  })
  const dirData = i18n.language === 'ar' ? 'rtl' : 'ltr'

  if (isLoading) {
    return <DotsLoader />
  }

  return (
    <div className={styles.wrapper}>
      <Heading title={sectionTitle} />
      <div dir={dirData} id={'cardWrapper'} className={styles.cardWrapper}>
        {data.cast.map((item: CastMember, index: number) => item.profile_path ? (
          <ActorCard
            key={index}
            actorId={item.person?.id}
            fullName={item?.name || item?.original_name}
            description={item.character}
            image={`${process.env.REACT_APP_IMG_BASE_URL}${item.profile_path}`}
          />
        ) : (null))}
      </div>
    </div>
  )
}

export default MainActorsList
